Backbone = require 'backbone'
Backbone.$ = $
FaqTrendingArticlesTemplate = require('../../trending_articles.html.mustache')

class FAQTrendingArticlesView extends Backbone.View

  initialize: ->
    @I18nScope = 'modules.faq'
    @template = FaqTrendingArticlesTemplate
    @container = $('#trending-articles')

  events :
    "click .article-header": "toggleArticleSummary"
    "click .rating"  : "handleRatingClicked"

  toggleArticleSummary: (event)->
    $target = $(event.target).closest('.article-header')
    id = $target.find('.article').attr('articleId')
    @resetAllArticlesExceptTarget(id)
    $("##{id}").toggle()
    $target.find('.icon-arrow-right').toggle()
    $target.find('.icon-arrow-down').toggle()
    scrollTo($target)

  resetAllArticlesExceptTarget: (targetId) ->
    _.each($('.article'), (article) =>
      id = $(article).attr('articleId')
      if id != targetId
        $target = $(article).closest('.article-header')
        $("##{id}").hide()
        $target.find('.icon-arrow-right').show()
        $target.find('.icon-arrow-down').hide()
    )

  render:() ->
    @toHtml()

  handleRatingClicked: (event) ->
    $target = $(event.target).closest('.rating')
    $target.find('.ratings').hide()
    $target.find('.thanks').show()
    return true

  toHtml: () ->
    @$el.html toHtml(@template, {trendingArticleList: @model.get('faqMain')?.trending_articles}, @I18nScope)
    @container.html(@el)

module.exports = FAQTrendingArticlesView
